module.exports = "<a href=\"javascript:;\" class=\"btn btn-follow ss-icon-plus\"></a>\n"